"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ArrowLeft, Menu } from "lucide-react";
import { useState } from "react";
import { TrackShareLogo } from "../../_components/TrackShareLogo";
import { Button } from "@src/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@src/components/ui/sheet";
import { navigation } from "./navigation";
import { paths } from "@src/utils/paths";
export function MobileNav() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  return <div className="md:hidden fixed top-0 left-0 right-0 z-10 bg-background border-b border-border" data-sentry-component="MobileNav" data-sentry-source-file="mobile-nav.tsx">
      <div className="flex items-center justify-between h-14 px-4">
        <div className="flex items-center gap-2">
          <Sheet open={open} onOpenChange={setOpen} data-sentry-element="Sheet" data-sentry-source-file="mobile-nav.tsx">
            <SheetTrigger asChild data-sentry-element="SheetTrigger" data-sentry-source-file="mobile-nav.tsx">
              <Button variant="ghost" size="icon" className="h-9 w-9" data-sentry-element="Button" data-sentry-source-file="mobile-nav.tsx">
                <Menu className="h-5 w-5" data-sentry-element="Menu" data-sentry-source-file="mobile-nav.tsx" />
                <span className="sr-only">Open menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-72 p-0" data-sentry-element="SheetContent" data-sentry-source-file="mobile-nav.tsx">
              <SheetHeader className="p-4 border-b border-border" data-sentry-element="SheetHeader" data-sentry-source-file="mobile-nav.tsx">
                <SheetTitle className="flex items-center gap-2 text-left" data-sentry-element="SheetTitle" data-sentry-source-file="mobile-nav.tsx">
                  <TrackShareLogo size={28} data-sentry-element="TrackShareLogo" data-sentry-source-file="mobile-nav.tsx" />
                </SheetTitle>
              </SheetHeader>
              <nav className="flex-1 px-3 py-4 space-y-6 overflow-y-auto max-h-[calc(100vh-8rem)]">
                {navigation.map(section => <div key={section.title}>
                    <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2 px-3">
                      {section.title}
                    </div>
                    <div className="space-y-0.5">
                      {section.items.map(item => {
                    const isActive = pathname === item.href;
                    return <Link key={item.name} href={item.href} onClick={() => setOpen(false)} className={`flex items-center gap-3 px-3 py-2 text-sm rounded-lg transition-colors ${isActive ? "bg-primary/10 text-primary font-medium" : "text-muted-foreground hover:text-foreground hover:bg-accent"}`}>
                            <item.icon className="h-4 w-4" />
                            {item.name}
                          </Link>;
                  })}
                    </div>
                  </div>)}
              </nav>
              <div className="border-t border-border p-3">
                <Link href={paths.root} className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors" data-sentry-element="Link" data-sentry-source-file="mobile-nav.tsx">
                  <ArrowLeft className="h-4 w-4" data-sentry-element="ArrowLeft" data-sentry-source-file="mobile-nav.tsx" />
                  Back to app
                </Link>
              </div>
            </SheetContent>
          </Sheet>
          <Link href={paths.docs.index} className="flex items-center gap-2 text-foreground font-semibold" data-sentry-element="Link" data-sentry-source-file="mobile-nav.tsx">
            <span>Docs</span>
          </Link>
        </div>
        <Link href={paths.root} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors" data-sentry-element="Link" data-sentry-source-file="mobile-nav.tsx">
          <ArrowLeft className="h-4 w-4" data-sentry-element="ArrowLeft" data-sentry-source-file="mobile-nav.tsx" />
          <span className="sr-only sm:not-sr-only">Back to app</span>
        </Link>
      </div>
    </div>;
}